<template>
  <div class=" container-fluid container-fixed-lg bg-white app-table-container">
  </div>
</template>

<script>

export default {};
</script>
